import React, { useEffect, useState } from 'react'
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { AiOutlinePlus, AiOutlineCheck } from "react-icons/ai";
import axios from 'axios';
import { gettoken } from '../Localstorage/Store';
import { IoIosArrowDown } from "react-icons/io";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {  useSelector } from "react-redux";
import Accountprice from '../utils/Accountprice';
import { Button } from '@mui/material';

export const Mycredit = () => {


  const { bgColor, textColor } = useSelector((state) => state.theam);

  const nvg = useNavigate()
  const [data, setData] = useState([]);
  const [datatwo, setDatatwo] = useState([]);
  const [error, seterror] = useState("No Records found !");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  console.log("this is value",startDate,endDate)


  const [datastatus, setDatastatus] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  // console.log("selectedStatus", selectedStatuses)
  const [selectedDuration, setSelectedDuration] = useState(null);
  // console.log(selectedDuration, "selectedDuration")



  const [userloader, setuserloader] = useState(false);
  const [creditamount, setcreditamount] = useState(0);

  const tokenvalue = gettoken();
  const [loading, setloading] = useState(false)
  const currentwdith = window.innerWidth;





console.log("ggggggggggggg",datatwo)

  const clearFilter = () => {
    setSelectedStatuses([]); // Clear selectedStatuses array
    setSelectedDuration(null);
    fetchcategory() // Reset selectedDuration to null (or initial value)
  };

  useEffect(() => {
    async function fetchstatus() {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      let url = `${process.env.REACT_APP_API_URL}credit/credit-history/`;

      const response = await axios.get(url, config);
      setDatastatus(response.data);
    }



    async function creditAmountCheck() {
      // console.log(tokenvalue.access);
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${tokenvalue.access}`,
          },
        };
        setuserloader(true);
        let url = `${process.env.REACT_APP_API_URL}credit/total_amount/`;
        const response = await axios.get(url, config);
        // console.log("this is wallet amount", response);
        // console.log(response.status);
        if ((response.status = "200")) {
          setcreditamount(response.data.amount);
          // setcreditminusamount(response.data.minus_amount)
          // setcreditshippingstatus(response.data.shipping_value)
        // settotalcredit(response.data.amount);
          // setuserloader(false);
          // console.log(response.amount);
          // return response.data.amount;
        }

        //  setloading(false)
      } catch (error) {}
    }

    creditAmountCheck()
    fetchstatus()

  }, [])
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = async () => {
    if (searchTerm == '') {
      fetchcategory()
    } else {
      const searchTermLower = searchTerm.trim().toLowerCase();

      const filteredOrders = data.filter(order =>
        order.number.toLowerCase().includes(searchTermLower)
      );
      setData(filteredOrders)

      // console.log('Filtered orders:', filteredOrders);
      if (data.length > 0 && selectedDuration) {
        if (selectedDuration == '360') {
          const errorMessage = "No orders found last one year "
          seterror(errorMessage);

        } if (selectedDuration == '180') {
          const errorMessage = "No orders found last six Month "
          seterror(errorMessage);

        }
        if (selectedDuration == '30') {
          const errorMessage = "No orders found last 30 Days "
          seterror(errorMessage);

        }
        if (selectedDuration == '15') {
          const errorMessage = "No orders found last 15 Days "
          seterror(errorMessage);

        }



      }
    }

  };



  async function fetchcategory(date=null) {
    setloading(true)
    

    let url = `${process.env.REACT_APP_API_URL}credit/credit-history/`;

      if (date) {
        url += `?start_date=${date.from_date}&end_date=${date.to_date}`;
      }

    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
      },
    };
    const response = await axios.get(url,config);
    setData(response.data.history);
    setloading(false)
  }
  useEffect(() => {
    fetchcategory()

  }, [])





const [statementerror,setstatementerror] = useState('')
const statement = async () => {
    setloading(true)
        try {
          let data = {user: tokenvalue.id};
          const config={headers:{Authorization: `Bearer ${tokenvalue.access}`}};
          let url=`${process.env.REACT_APP_API_URL}credit/credit-history-csv/?start_date=${startDate}&end_date=${endDate}`;
          const response=await axios.get(url, config);
          const blob=new Blob([response.data],{ type: 'application/pdf' });
          const pdfUrl=window.URL.createObjectURL(blob);
          window.open(pdfUrl, '_blank');
          const link=document.createElement('a');
          link.href=pdfUrl;
          link.setAttribute('download', 'credit-history.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(pdfUrl);

          //  setDatatwo(parsedData);
          //  setstatementerror('')
          //  handleDownloadPDF(parsedData)
         
        } catch (error) {
          setloading(false)
          if(error.response){
            if(error.response.data.error == 'Credit not found'){
              setstatementerror("Credit history not found");
              setTimeout(() => {setstatementerror('')}, 4000);
            }
          }
        }
      };





      
      
        
      
    



  return (
    <div>
      <Header />

      <div>
        {/* breadcrumb start */}
        <div className="breadcrumb-main marginfromtop" style={{ background: "#fff" }}>
          <div className="container m-0">
            <div className="row">
              <div className="col">
                <div className="breadcrumb-contain">
                  <div>
                    <ul>
                      <li><a href="/home">home</a></li>
                      <li onClick={()=>{statement()}}>{`>`}</li>
                      <li><a href="javascript:void(0)" >My Credits </a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* breadcrumb End */}
        <div>
          <section className="section-big-pt-space py-1 " style={{ background: "#f9f9f9" }}>
            <div className="col-lg-12 col-sm-12 col-xs-12 mt-lg-4 mt-xs-4 mb-5">

              <div className="container-fuild emp-profile">
                <div className="row pro justify-content-center">


                  {/* <div id="tab-2" style={{ display: owl == 'tab-2' ? 'block' : 'none' }} className={owl == 'tab-2' ? "tab-content active default product-block3" : "tab-content product-block3"}> */}
                  <div className="row py-xl-4 py-3">

 <div className={"col-xl-10 col-md-12 offset-xl-1 offset-md-0 Ohistory"} style={{ padding: "0px 4px" }} >
                      <h3 className='pb-xl-0 pb-md-0 pb-2' style={{  color: `#${textColor}`}}
                      > My Credits </h3>
                      </div>


                    <div className={"col-xl-10 col-md-12 offset-xl-1 offset-md-0 Ohistory"} style={{ padding: "0px 4px" }} >
                      <div className="input-group mb-2" style={{ gap: '10px', justifyContent: 'space-between',alignItems:'end' }}>
                        <span>
                        {tokenvalue.company_name && (
                            <span style={{ display: 'block' }}>
                              Company Name : <span style={{ textTransform: 'uppercase' }}>{tokenvalue.company_name}</span>
                            </span>
                          )}

                          {tokenvalue.client_id && (
                            <span style={{ display: 'block', paddingTop: '3px' }}>
                              Account ID : {tokenvalue.client_id}
                            </span>
                          )}

                          <span style={{ display: 'block', paddingTop: '3px' }}>
                            Credits Available : {" "}
                            <span style={{
                              display: 'inline-block',
                              padding: '2px 5px',
                              border: '1px solid #ddd',
                              borderRadius: '10px',
                              backgroundColor: '#0CB744',
                              fontSize: '14px',
                              color: '#ffff',
                              textAlign: 'center',
                              fontWeight: '500',
                              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                            }}>
                              {Accountprice(creditamount).replace('₹', '')}
                            </span>
                        
                          </span>
                          <span style={{ display: 'block', paddingTop: '3px' }}>    
                            <span>Expiry Date : </span> 
                          <span style={{ fontSize: '14px',
                              color: '#333',
                              textAlign: 'center',
                              fontWeight: '500',
                              marginRight : "4px"}}>
                                {datastatus.end_date}
                                
                                </span>
                                {(datastatus.expiry_duration || creditamount == 0) && (
                                <span style={{ 
                                  display: 'inline-block', 
                                  padding: '6px 12px', 
                                  backgroundColor: '#ffe5e5', 
                                  borderRadius: '20px', 
                                  fontWeight: '600',
                                  fontSize: '14px',
                                  color: '#d32f2f'
                                }}>
                                  {datastatus.expiry_duration === 'Expired' || creditamount == 0 
                                    ? 'Expired' 
                                    : `${datastatus.expiry_duration} days left`}
                                </span>
                              )}



                                
                                </span>



                        </span>
          
                      </div>
                    <div>
                      <div class="d-block d-md-flex" style={{  justifyContent: "space-between", marginBottom : "10px" }}>
    
                        <span style={{fontSize:'19px',fontWeight:'500'}}>
                        Transactions History
                        </span>
                        <div style={{display:'flex',gap:'3px'}}>
                        <button
                          className='Sbtn btn btn-outline-secondary'
                          style={{ 
                            background: `#${bgColor}`
                            , color: 'white',padding:'5px 6px', borderRadius: '0px', fontSize: "13px" }}
                          type="button"
                          id="button-addon2"
                          onClick={() => { nvg('/creditrequest') }}
                        >
                          <span style={{ fontSize: '18px' }}>+</span>&nbsp; Request Credits
                        </button>

                        <button
                          className='Sbtn btn btn-outline-secondary'
                          style={{  backgroundColor: `#${bgColor}`, color: 'white',padding:'5px 6px', borderRadius: '0px', fontSize: "13px",textWrap:'nowrap' }}
                          type="button"
                          id="button-addon2"
                          onClick={() => { nvg('/voucher-request-add') }}
                        >
                          <span style={{ fontSize: '18px' }}>+</span>&nbsp; Request Voucher
                        </button>
                        </div>

                        </div>
                    
                      </div>
                      <div className="filter-main-btn m-0" style={{ display: currentwdith < 730 ? "block" : "none" }} >          <button
                        type="button"
                        className="hidecontent my-2"
                        style={{
                          border: "none",
                          outline: "none",
                          backgroundColor: "white",
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalfour"
                      >
                      </button></div>

                      <div className="table-responsive" >
                        <table className="table  orstatus" >

                          <thead>
                            <tr>

                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>S.No</div></th>
                              
                            
 <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Transaction Id </div></th>
 <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Transaction Type </div></th>
                             






                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Credit Amount</div></th>
                                 
                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}> Date</div></th>
                            
                            </tr>
                          </thead>
                          {/* </table> */}



                          <thead className="table-light" style={{ paddingTop: '20px' }}>
                            <tr>

                            </tr>
                          </thead>
                          <tbody >
                            {data[0] ? (data.map((item, index) => (
                              <tr key={index}>


                                <td style={{ color: '#230BB3', paddingTop: '20px', textAlign: "center", fontSize: '12px' }}>

                                  <h5
                                    style={{ fontSize: "12px", lineHeight: "22px", cursor: 'pointer', position: 'relative' }}> {1 + index}</h5>
                                </td>
                                {/* <td style={{ color: '', paddingTop: '20px', textAlign: "center", fontSize: '12px' }}>

                    
                                  {item.voucher_request_name}
                          
                                </td> */}



                                <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px' }}>{item.order_number == null ? item.credit_request : item.order_number}</td>
                                <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px' }}>{item.credit_type}</td>


                                {/* <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px', position: 'relative', left: "10px" }}>{item.no_of_vouchers} </td> */}
                                <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px', color: item.credit_used_amount > 0 ? "green" : "red" }}>
                              {Accountprice(item.credit_used_amount).replace('₹', '')}
                            </td>
                                

                                <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px', }}>
                                   {new Date(item.credit_used_time.split('Time')[0]).toLocaleDateString('en-GB', {
                                  hour: 'numeric',
                                  minute: 'numeric'
                                }


                                )}
                                </td>


                                {/* <td className='d-flex justify-content-center'>
                                  <p style={{ paddingTop: '15px', width: "115px", fontSize: '12px', textAlign: 'center' }}>  &nbsp;      
                                             {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                  </p>
                                </td> */}

                              </tr>
                            ))) : (
                              <tr>
                                <td
                                  colSpan={5}
                                  className="text-center"
                                  style={{ fontWeight: "500" }}
                                >
                                  {error}
                                </td>
                              </tr>
                            )}



                          </tbody>
                        </table>
                      </div>

                      <div className="col-xl-12 d-flex justify-content-end convertdesign" >
                    <div className='d-flex align-items-end convertdesign' style={{gap:'4px'}}>
<div style={{display:'flex',gap:'4px'}}>
  <div>
    <label htmlFor="" className='mb-0' >Start Date</label>
                    <input
                    type='date'
                    className="form-control custom-select"
                    placeholder='start date'
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    style={{borderRadius: "0px",fontSize:'13px' }}
                    />
                    </div>
                    <div>
                      <label className='mb-0' htmlFor="">End Date</label>
         <input
                    type='date'
                    className="form-control custom-select"
                    placeholder='end date'
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{borderRadius: "0px",fontSize:'13px' }}
                    />
                    </div>
          </div>

                                    <button
                            className='Sbtn btn btn-outline-secondary'
                            style={{
                              backgroundColor: `#${bgColor}`,
                              color: 'white',
                              borderRadius: '0px',
                              fontSize: '13px',
                              textWrap: 'nowrap',
                              cursor: startDate && endDate ? 'pointer' : 'not-allowed',
                              opacity: startDate && endDate ? 1 : 0.6
                            }}
                            type="button"
                            disabled={!startDate || !endDate}
                            onClick={() => {
                              if (startDate && endDate) {
                                const formattedDate = {
                                  from_date:startDate,
                                  to_date:endDate
                                }
                                fetchcategory(formattedDate);
                              }
                            }}
                          >
                            Apply
                          </button>

                      {endDate == null || startDate == null ? 
                      <button
                                  className='Sbtn btn btn-outline-secondary'
                                  style={{  backgroundColor: `#${bgColor}`, color: 'white', borderRadius: '0px', fontSize: "13px",textWrap:'nowrap' }}
                                  type="button"
                                  // onClick={handleDownloadPDF}
                                  disabled
                                >
                                  DOWNLOAD                                
                                  </button> : <button
                                  className='Sbtn btn btn-outline-secondary'
                                  style={{  backgroundColor: `#${bgColor}`, color: 'white', borderRadius: '0px', fontSize: "13px",textWrap:'nowrap' }}
                                  type="button"
                                  onClick={()=>{statement()}}
                                >
                                    DOWNLOAD                                
                                    </button>}
                    </div>
                    </div>
                    <div style={{display:'flex',justifyContent:'end'}}>
                                <span style={{color:'red',paddingTop:'4px'}}>{statementerror}</span>
                    </div>

                    </div>

                  </div>






                </div>
              </div>
            </div>
          </section>

        </div>


        <Footer />
      </div>


    </div>
  )
}
export default Mycredit;